module.exports = __webpack_public_path__ + "images/55b069bbc2b8fa42e5b8047c014bd8a4.svg";